import React from 'react';
import type { CertCardProps } from '../achievements.types';

// * [COMPONENT] Certificate achievement card showing image preview and metadata
export const CertCard: React.FC<CertCardProps> = ({ cert, onSelect }) => {
  return (
    <div
      className="cert-card"
      onClick={() => onSelect(cert)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect(cert);
        }
      }}
      aria-label={`View certificate for ${cert.title}`}
    >
      {/* * Certificate image preview */}
      <div className="cert-card-image-wrap">
        <img
          src={cert.image}
          alt={`${cert.title} certificate`}
          className="cert-card-image"
          loading="lazy"
        />
        <div className="cert-card-image-overlay">
          <i className="fas fa-search-plus" aria-hidden="true" />
        </div>
      </div>

      {/* * Certificate metadata */}
      <div className="cert-card-body">
        <div className="cert-card-year-badge">{cert.year}</div>
        <h4 className="cert-card-title">{cert.title}</h4>
        <div className="cert-card-issuer">{cert.issuer}</div>
        <p className="cert-card-desc">{cert.description}</p>
        <div className="cert-card-cta">
          <i className="fas fa-award" aria-hidden="true" />
          <span>View Certificate</span>
        </div>
      </div>
    </div>
  );
};

export default CertCard;
